import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { usePaddle } from '~/util';
import { setPaymentProviderOverride } from '~/Redux/Modules/PaymentProvider';
import config from '~/Config';

import './PaymentProviderSelector.scss';

const PaymentProviderSelector = () => {
  const dispatch = useDispatch();
  const override = useSelector(({ PaymentProvider }) => PaymentProvider.override);
  const usePaddleValue = usePaddle(override);

  const handleChange = value => {
    dispatch(setPaymentProviderOverride(value === 'null' ? null : value === 'true'));
  };

  const showPaymentProviderSelector =
    config.automaticallyShowPaymentSwitcher ||
    window.localStorage.getItem('showPaymentProviderSelector');

  if (!showPaymentProviderSelector) {
    return null;
  }

  return (
    <div className="payment-provider-selector">
      <div className="payment-provider-selector__label">
        Payment Provider: {usePaddleValue ? 'Paddle' : 'Stripe'}
      </div>
      <div className="payment-provider-selector__controls">
        <button
          className={`payment-provider-selector__button ${override === true ? 'active' : ''}`}
          onClick={() => handleChange('true')}
        >
          Paddle
        </button>
        <button
          className={`payment-provider-selector__button ${override === false ? 'active' : ''}`}
          onClick={() => handleChange('false')}
        >
          Stripe
        </button>
        <button
          className={`payment-provider-selector__button ${override === null ? 'active' : ''}`}
          onClick={() => handleChange('null')}
        >
          Auto
        </button>
      </div>
    </div>
  );
};

export default PaymentProviderSelector;
